import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Row,
  Card,
  CardBody,
  Col,
  Container,
  Table,
  Input,
  InputGroup,
  InputGroupText,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input as SelectInput,
  Spinner,
} from "reactstrap";
import { post, get, uri, postJsonRaw } from "helpers/api_helper";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import * as api from "../../constants/api_constants";
import CustomPagination from "components/CustomPagination";
import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from "helpers/toastMessages";
import { CustomButton } from "components/CommonInputs/CustomButtons/CustomButton";
import SummaryCards from "components/SummaryCards";
import Papa from "papaparse";
import CertificatePreview from "./CertificatePreview";
import axios from "axios";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";
import Signature from "../../assets/images/Sign.png";
import CertificateLayout from "../../assets/images/certificateLogos/CertificateLayout.svg";
import ReactDOM from "react-dom/client";

// Certificate component for PDF generation
const Certificate = ({
  title,
  recipientName,
  companyName,
  issueDate,
  description,
}) => {
  // Function to parse description and render bold dynamic values
const renderDescription = (desc) => {
  if (typeof desc !== "string") return desc; // guard

  // Split on <strong>...</strong> OR <br/> OR <br>
  const parts = desc.split(/(<strong>.*?<\/strong>|<br\s*\/?>)/g);

  return parts.map((part, index) => {
    if (part.startsWith("<strong>") && part.endsWith("</strong>")) {
      const text = part.replace(/<\/?strong>/g, "");
      return (
        <span key={index} style={{ fontWeight: "bold" }}>
          {text}
        </span>
      );
    }
    if (part.match(/<br\s*\/?>/)) {
      return <br key={index} />;
    }
    return <span key={index}>{part}</span>; // normal text
  });
};

  return (
    <div
      id="certificate"
      className="flex items-center justify-center border border-gray-800 rounded-xl relative bg-white overflow-hidden"
      style={{
        minHeight: "120vh",
        width: "100%",
        maxWidth: "1280px",
        position: "relative",
      }}
    >
      <img
        src={CertificateLayout}
        alt="Layout"
        style={{
          width: "100%",
        }}
      />
      <div
        className="relative z-10 text-center max-w-3xl w-full text-black"
        style={{
          position: "absolute",
          top: 168,
          left: 90,
        }}
      >
        <h1
          className="text-[10rem] mb-4"
          style={{
            fontFamily: "'Dancing Script', cursive",
            fontSize: "75px",
            paddingRight: "30px",
          }}
        >
          Certificate
        </h1>
        <h2
          className="mb-6 tracking-widest"
          style={{
            fontFamily: "'Oleo Script', cursive",
            paddingRight: "30px",
            fontSize: "20px",
          }}
        >
          {title.toUpperCase()}
        </h2>
        <p
          className="text-xs text-gray-500 mb-2"
          style={{
            fontFamily: "'Oleo Script', cursive",
            paddingRight: "30px",
            fontSize: "15px",
          }}
        >
          This certificate is proudly presented to
        </p>
        <div
          className="text-xl font-bold text-gray-900 border-b-2 border-gray-300 w-[300px] mx-auto"
          style={{
            fontFamily: "'Dancing Script', cursive",
            fontSize: "30px",
            paddingRight: "30px",
          }}
        >
          {recipientName}
        </div>
        <hr
          className="mt-1 mb-4"
          style={{
            position: "relative",
            width: "23em",
            borderWidth: "2px",
            left: "23em",
          }}
        />
        <p
          className="text-sm text-gray-600 mb-3 font-bold"
          style={{
            fontFamily: "'Oleo Script', cursive",
            fontWeight: "bold",
            paddingRight: "30px",
          }}
        >
          From "Elbert Technology"
        </p>
        <p
          style={{
            fontFamily: "'Oleo Script', cursive",
            fontWeight: "bold",
            paddingRight: "30px",
            fontSize: "12px",
          }}
        >
          Reg.No: U72900TG2023PTC170069
        </p>
        <p
          className="text-base text-gray-700 mb-6 px-10"
          style={{
            width: "75em",
            fontFamily: "'Oleo Script', cursive",
            fontWeight: 400,
            fontStyle: "normal",
            fontSize: "13px",
            lineHeight: "30px",
            textAlign: "center",
            color: "#000000",
          }}
        >
          {renderDescription(description)}
        </p>
        <Row className=" ms-3">
          <Col className="mt-1">
            <p
              className="text-sm font-bold text-gray-700 mt-2"
              style={{
                fontFamily: "'Oleo Script', cursive",
                position: "relative",
                width: "10em",
                fontWeight: "bold",
              }}
            >
              {issueDate}
            </p>
            <hr
              className=" mb-2 border-gray-300"
              style={{
                position: "relative",
                width: "10em",
                borderWidth: "2px",
              }}
            />
            <p
              className="text-sm text-gray-400"
              style={{
                position: "relative",
                width: "10em",
                borderWidth: "2px",
                fontFamily: "'Oleo Script', cursive",
              }}
            >
              Issued Date
            </p>
          </Col>
          <Col
            className="text-right"
            style={{ position: "relative", top: 0, left: 30 }}
          >
            <img
              src={Signature}
              alt="Signature"
              style={{
                width: "118px",
                height: "auto",
                marginLeft: "50px",
                marginTop: "10px",
              }}
            />
            <hr
              className="mt-2 mb-2 border-gray-300"
              style={{
                position: "relative",
                width: "20em",
                borderWidth: "2px",
                left: "7em",
              }}
            />
            <p
              className="text-sm font-semibold mt-2 ms-5"
              style={{
                fontFamily: "'Oleo Script', cursive",
              }}
            >
              Prasanthi Rangisetti, Director
            </p>
          </Col>
        </Row>
      </div>
    </div>
  );
};

function Certificates() {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  // State for certificates, search query, pagination, modal, counts, and selected certificate type
  const [totalCertificates, setTotalCertificates] = useState({
    certificates: [],
    error: "",
  });
  const [countsByType, setCountsByType] = useState({
    totalCount: 0,
    INTERNSHIP: 0,
    APPRECIATION: 0,
    ACHIEVEMENT: 0,
    HACKATHON_WINNER: 0,
    HACKATHON_PARTICIPATION: 0,
    MOST_VALUABLE_PERSON: 0,
    BEST_TEAM: 0,
    LEADERS_CHOICE: 0,
    GREAT_WORK: 0,
    STAR_OF_THE_MONTH: 0,
    STAR_OF_THE_QUARTER: 0,
    STAR_PERFORMER: 0,
    COURSE_COMPLETION: 0,
    TRAINING_COMPLETION: 0,
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCertificateType, setSelectedCertificateType] = useState("All");
  const [apiStatus, setApiStatus] = useState({ loading: false });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [csvFile, setCsvFile] = useState(null);
  const [csvData, setCsvData] = useState([]);
  const [bulkCertificateType, setBulkCertificateType] = useState("");
  const [isBulkUploadLoading, setIsBulkUploadLoading] = useState(false);
  const timerRef = useRef(null);

  // Certificate types for dropdown
  const certificateTypes = [
    "All",
    ...Object.keys(countsByType).filter((key) => key !== "totalCount"),
  ];

  // Example Excel data for each certificate type
  const exampleExcelData = {
    internship: [
      {
        recipientName: "John Doe",
        courseType: "Software Development",
        startDate: "2025-01-01",
        endDate: "2025-03-31",
        duration: "90",
        issueDate: "2025-04-01",
        email: "john.doe@example.com",
        mobileNumber: "1234567890",
      },
    ],
    appreciation: [
      {
        recipientName: "Jane Smith",
        department: "Marketing",
        issueDate: "2025-04-01",
        email: "jane.smith@example.com",
        mobileNumber: "0987654321",
      },
    ],
    achievement: [
      {
        recipientName: "Alice Johnson",
        department: "Engineering",
        issueDate: "2025-04-01",
        email: "alice.johnson@example.com",
        mobileNumber: "1122334455",
      },
    ],
    hackathon_winner: [
      {
        recipientName: "Bob Brown",
        hackathonName: "TechFest 2025",
        issueDate: "2025-04-01",
        email: "bob.brown@example.com",
        mobileNumber: "2233445566",
      },
    ],
    hackathon_participation: [
      {
        recipientName: "Carol White",
        hackathonName: "TechFest 2025",
        issueDate: "2025-04-01",
        email: "carol.white@example.com",
        mobileNumber: "3344556677",
      },
    ],
    most_valuable_person: [
      {
        recipientName: "David Lee",
        issueDate: "2025-04-01",
        email: "david.lee@example.com",
        mobileNumber: "4455667788",
        startDate: "2025-01-01",
        endDate: "2025-03-31",
      },
    ],
    best_team: [
      {
        recipientName: "Team Alpha",
        teamName: "Alpha Innovators",
        issueDate: "2025-04-01",
        email: "team.alpha@example.com",
        mobileNumber: "5566778899",
      },
    ],
    leaders_choice: [
      {
        recipientName: "Emma Davis",
        issueDate: "2025-04-01",
        email: "emma.davis@example.com",
        mobileNumber: "6677889900",
        startDate: "2025-01-01",
        endDate: "2025-03-31",
      },
    ],
    great_work: [
      {
        recipientName: "Frank Wilson",
        issueDate: "2025-04-01",
        email: "frank.wilson@example.com",
        mobileNumber: "7788990011",
        startDate: "2025-01-01",
        endDate: "2025-03-31",
      },
    ],
    star_of_the_month: [
      {
        recipientName: "Grace Taylor",
        issueDate: "2025-04-01",
        email: "grace.taylor@example.com",
        mobileNumber: "8899001122",
        startDate: "2025-01-01",
        endDate: "2025-03-31",
      },
    ],
    star_of_the_quarter: [
      {
        recipientName: "Henry Martinez",
        issueDate: "2025-04-01",
        email: "henry.martinez@example.com",
        mobileNumber: "9900112233",
        startDate: "2025-01-01",
        endDate: "2025-03-31",
      },
    ],
    star_performer: [
      {
        recipientName: "Isabella Anderson",
        issueDate: "2025-04-01",
        email: "isabella.anderson@example.com",
        mobileNumber: "0011223344",
        startDate: "2025-01-01",
        endDate: "2025-03-31",
      },
    ],
    course_completion: [
      {
        recipientName: "James Thomas",
        courseName: "Advanced Java",
        issueDate: "2025-04-01",
        startDate: "2025-01-01",
        endDate: "2025-03-31",
        email: "james.thomas@example.com",
        mobileNumber: "1122334455",
      },
    ],
    training_completion: [
      {
        recipientName: "Kelly Roberts",
        trainingProgramName: "Project Management",
        issueDate: "2025-04-01",
        startDate: "2025-01-01",
        endDate: "2025-03-31",
        email: "kelly.roberts@example.com",
        mobileNumber: "2233445566",
      },
    ],
  };

  const fetchData = useCallback(
    async (query = "", page = 1, certificateType = "All") => {
      try {
        setApiStatus((prev) => ({ ...prev, loading: true }));

        const certificatesData = await post(api.GET_ALL_CERTIFICATES, {
          certificateType: certificateType === "All" ? "" : certificateType,
          searchKeyword: query?.trim() ?? "",
          page: page - 1,
          pageSize: 10,
          sortBy: "certificateNumber",
          direction: "asc",
        });

        const certCount = await get(api.CERTIFICATES_COUNT);

        if (certCount.success && certCount.data?.countsByType) {
          const defaultCounts = {
            totalCount: 0,
            INTERNSHIP: 0,
            APPRECIATION: 0,
            ACHIEVEMENT: 0,
            HACKATHON_WINNER: 0,
            HACKATHON_PARTICIPATION: 0,
            MOST_VALUABLE_PERSON: 0,
            BEST_TEAM: 0,
            LEADERS_CHOICE: 0,
            GREAT_WORK: 0,
            STAR_OF_THE_MONTH: 0,
            STAR_OF_THE_QUARTER: 0,
            STAR_PERFORMER: 0,
            COURSE_COMPLETION: 0,
            TRAINING_COMPLETION: 0,
          };

          setCountsByType({
            ...defaultCounts,
            ...certCount.data.countsByType,
            totalCount: certCount.data.totalCount ?? 0,
          });
        }

        if (certificatesData?.data?.items) {
          setTotalCertificates((prev) => ({
            ...prev,
            certificates: certificatesData?.data?.items || [],
            error: "",
          }));
          setTotalPages(certificatesData?.data.totalPages || 0);
        }
      } catch ({ response: { data: { message } = {} } = {} }) {
        setTotalCertificates((prev) => ({
          ...prev,
          certificates: [],
          error: message ?? "Failed to fetch certificates",
        }));
      }

      setApiStatus((prev) => ({ ...prev, loading: false }));
    },
    []
  );

  const handleDownload = useCallback(
    async (certificatePdf, certificateNumber) => {
      if (!certificatePdf) {
        showWarningToast("No file associated with this certificate.");
        return;
      }

      const mimeType = "application/pdf";
      try {
        const response = await axios.get(
          `${uri}/fileservice/api/files/download/${certificatePdf}`,
          {
            responseType: "blob",
          }
        );

        const blob = new Blob([response.data], { type: mimeType });
        if (blob.size === 0) {
          showErrorToast("Downloaded file is empty.");
          return;
        }

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `certificate_${certificateNumber}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        showSuccessToast("Certificate downloaded successfully");
      } catch (err) {
        console.error("Error downloading certificate:", err);
        let errorMessage = "Failed to download certificate.";
        if (err.response?.status === 404) {
          errorMessage = "Certificate file not found on the server.";
        } else if (err.response?.status === 401) {
          errorMessage =
            "Unauthorized access. Please check your authentication.";
        } else if (err.response?.status === 500) {
          errorMessage = "Server error. Please try again later.";
        }
        showErrorToast(errorMessage);
      }
    },
    []
  );

  useEffect(() => {
    fetchData(searchQuery, 1, selectedCertificateType);
  }, [fetchData, selectedCertificateType]);

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      fetchData(searchQuery, page, selectedCertificateType);
    },
    [fetchData, searchQuery, selectedCertificateType]
  );

  const handleSearch = useCallback(
    (e) => {
      setSearchQuery(e.target.value ?? "");
      const query = e.target.value || "";

      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      timerRef.current = setTimeout(() => {
        fetchData(query?.trim(), 1, selectedCertificateType);
      }, 300);
    },
    [fetchData, selectedCertificateType]
  );

  const handleCertificateTypeChange = useCallback(
    (e) => {
      setSelectedCertificateType(e.target.value);
      setCurrentPage(1);
      fetchData(searchQuery, 1, e.target.value);
    },
    [fetchData, searchQuery]
  );

  const handleView = useCallback(
    (id) => {
      navigate(`/view-certificates/${id}`);
    },
    [navigate]
  );

  const handleEdit = useCallback(
    (id) => {
      navigate(`/add-new-certificates/${id}`);
    },
    [navigate]
  );

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    if (isModalOpen) {
      setCsvFile(null);
      setCsvData([]);
      setBulkCertificateType("");
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    }
  };

  const handleCsvUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setCsvFile(file);

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (result) => {
        setCsvData(result.data);
      },
      error: (error) => {
        console.error("Error parsing CSV:", error);
        showErrorToast("Failed to parse CSV file");
      },
    });
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const handleBulkCertificateTypeChange = (e) => {
    setBulkCertificateType(e.target.value);
  };

  const handleDownloadExampleExcel = () => {
    if (!bulkCertificateType) {
      showErrorToast("Please select a certificate type first");
      return;
    }

    const data = exampleExcelData[bulkCertificateType.toLowerCase()];
    if (!data) {
      showErrorToast("No example Excel available for this certificate type");
      return;
    }

    // Create a worksheet from the data
    const worksheet = XLSX.utils.json_to_sheet(data);
    // Create a workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Example");

    // Generate Excel file and trigger download
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `example_${bulkCertificateType}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const getCertificateDetails = (data, type) => {
    if (!data || !type) {
      return {
        title: "Certificate",
        description: "Description will be populated after filling the form",
      };
    }

    switch (type) {
      case "internship":
        return {
          title: "of Internship",
          description: `This is to certify that '<strong>${
            data.recipientName || "[Recipient's Name]"
          }</strong>' has successfully completed the '<strong>${
            data.courseType || "[Course Type]"
          }</strong>' internship program at '<strong>${
            data.companyName || "Elbert Technology"
          }</strong>' from <strong>${formatDate(
            data.startDate
          )}</strong> to <strong>${formatDate(
            data.endDate
          )}</strong>, with a duration of <strong>${
            data.duration || "[Duration]"
          } days</strong>. During this period, he/she demonstrated exceptional dedication, a strong work ethic, and a keen willingness to learn, contributing significantly to ongoing projects and organizational goals. We commend his/her professionalism and innovative approach, which reflect the core values of our organization.`,
        };
      case "appreciation":
      case "achievement":
        return {
          title: `of ${
            type === "appreciation" ? "Appreciation" : "Achievement"
          }`,
          description: `This is to certify that '<strong>${
            data.recipientName || "[Recipient's Name]"
          }</strong>' has been recognized for outstanding contributions in the '<strong>${
            data.department || "[Department]"
          }</strong>' department at '<strong>${
            data.companyName || "Elbert Technology"
          }</strong>' on <strong>${formatDate(
            data.issueDate
          )}</strong>. Your dedication and excellence have significantly impacted our organization.`,
        };
      case "hackathon_winner":
        return {
          title: "of Hackathon Winner",
          description: `This certifies that <strong>${
            data.recipientName || "[Recipient's Name]"
          }</strong> has emerged as the winner of the <strong>${
            data.hackathonName || "[Hackathon Name]"
          }</strong> organized by <strong>${
            data.companyName || "Elbert Technology "
          }</strong>. Through exemplary problem-solving skills, creativity, and technical expertise, <strong>${
            data.pronoun || "He/She"
          }</strong> have demonstrated outstanding innovation and mastery, setting a benchmark for excellence. We celebrate this remarkable achievement and look forward to witnessing further groundbreaking accomplishments.`,
        };

      case "hackathon_participation":
        return {
          title: "of Hackathon Participation",
          description: `This is to certify that <strong>${
            data.recipientName || "[Recipient's Name]"
          }</strong> has actively participated in the <strong>${"Hackathon"}</strong> organized by <strong>${
            data.companyName || "Elbert Technology "
          }</strong> at <strong>${" Anurag Engineering College, Kodad"}</strong>. We appreciate [his/her] enthusiasm, collaborative spirit, and
          commitment to innovation displayed throughout the event.`,
        };

      case "best_team":
        return {
          title: "of Best Team",
          description: `This certifies that the <strong>${
            data.teamName || "[Team Name]"
          }</strong> has been honored as the Best Team at <strong>${
            data.companyName || "Elbert Technology "
          }</strong> for their exceptional collaboration, strategic problem-solving, and outstanding results. Your collective effort and synergy exemplify the spirit of teamwork and innovation, making a lasting impact on our organization.`,
        };

      case "course_completion":
        return {
          title: "of Course Completion",
          description: `This certifies that <strong>${
            data.recipientName || "[Recipient's Name]"
          }</strong> has successfully completed the <strong>${
            data.courseName || "[Course Name]"
          }</strong> at <strong>${
            data.companyName || "Elbert Technology "
          }</strong> from <strong>${formatDate(
            data.startDate
          )}</strong> to <strong>${formatDate(
            data.endDate
          )}</strong>. Your dedication to acquiring new skills and your commitment to professional growth have been commendable. We congratulate you on this accomplishment and encourage you to continue striving for excellence.`,
        };

      case "training_completion":
        return {
          title: "of Training Completion",
          description: `This is to certify that <strong>${
            data.recipientName || "[Recipient's Name]"
          }</strong> has successfully completed the <strong>${
            data.trainingProgramName || "[Training Program Name]"
          }</strong> conducted by <strong>${
            data.companyName || "Elbert Technology "
          }</strong> from <strong>${formatDate(
            data.startDate
          )}</strong> to <strong>${formatDate(
            data.endDate
          )}</strong>. Your active participation and eagerness to learn exemplify the values of continuous improvement and professional development.`,
        };

      case "most_valuable_person":
        return {
          title: "of Most Valuable Person (MVP)",
          description: `This certifies that <strong>${
            data.recipientName || "[Recipient's Name]"
          }</strong> has been recognized as the Most Valuable Person at <strong>${
            data.companyName || "Elbert Technology "
          }</strong> for the period from <strong>${formatDate(
            data.startDate
          )}</strong> to <strong>${formatDate(
            data.endDate
          )}</strong>. This recognition is awarded for demonstrating unwavering dedication, leadership qualities, and a proactive attitude that greatly contributed to the success of our team and organization. Your exemplary performance sets a standard for others and inspires continuous excellence.`,
        };

      case "leaders_choice":
        return {
          title: "of Leader’s Choice Award",
          description: `This is to recognize <strong>${
            data.recipientName || "[Recipient's Name]"
          }</strong> as the Leader’s Choice recipient at <strong>${
            data.companyName || "Elbert Technology "
          }</strong>. Your exemplary leadership, vision, and dedication have earned the admiration of your peers and supervisors alike. Your proactive approach and commitment to excellence make you a role model within our organization.`,
        };

      case "great_work":
      case "star_of_the_month":
      case "star_of_the_quarter":
        return {
          title: `of ${type.replace(/_/g, " ").toUpperCase()}`,
          description: `This certifies that <strong>${
            data.recipientName || "[Recipient's Name]"
          }</strong> has been honored as the Star of the Quarter at <strong>${
            data.companyName || "Elbert Technology "
          }</strong> for the period from <strong>${formatDate(
            data.startDate
          )}</strong> to <strong>${formatDate(
            data.endDate
          )}</strong>, in acknowledgment of your exceptional contributions, leadership, and consistent pursuit of excellence over the past three months. Your efforts have been instrumental in achieving organizational goals.`,
        };

      case "star_performer":
        return {
          title: `of Star performer`,
          description: `This is to certify that '<strong>${
            data.recipientName || "[Recipient's Name]"
          }</strong>' has been recognized for exceptional performance as '<strong>${type
            .replace(/_/g, " ")
            .toUpperCase()}</strong> at <strong>${
            data.companyName || "Elbert Technology"
          }</strong>' from <strong>${formatDate(
            data.startDate
          )}</strong> to <strong>${formatDate(
            data.endDate
          )}</strong>. Your Outstanding Achievements, Commitment To Quality, And Proactive Attitude Have Significantly Elevated Our Standards And Inspired Your Peers. `,
        };
      default:
        return {
          title: "Certificate",
          description: `For your valued contributions at <strong>${
            data.companyName || "Elbert Technology"
          }</strong>.`,
        };
    }
  };

  const generateCertificatePDF = async (
    certificateData,
    certificateType,
    index
  ) => {
    const div = document.createElement("div");
    div.style.position = "absolute";
    div.style.left = "-9999px";
    document.body.appendChild(div);

    try {
      const { title, description } = getCertificateDetails(
        certificateData,
        certificateType
      );
      const recipientName = certificateData.recipientName || "[Recipient Name]";
      const companyName = certificateData.companyName || "Elbert Technology";
      const issueDate =
        formatDate(certificateData.issueDate) || formatDate(new Date());

      // Define A4 dimensions in pixels at 96 DPI
      const a4WidthPx = 1123; // 297mm * 96 DPI / 25.4 mm/inch ≈ 1123px
      const a4HeightPx = 794; // 210mm * 96 DPI / 25.4 mm/inch ≈ 794px

      // Set the container to A4 dimensions
      div.style.width = `${a4WidthPx}px`;
      div.style.height = `${a4HeightPx}px`;
      div.style.overflow = "hidden";

      // Detect browser zoom level
      const zoomLevel = window.devicePixelRatio || 1;
      const scaleFactor = 1 / zoomLevel; // Counteract browser zoom

      const root = ReactDOM.createRoot(div);
      root.render(
        <Certificate
          title={title}
          recipientName={recipientName}
          companyName={companyName}
          issueDate={issueDate}
          description={description}
        />
      );

      await new Promise((resolve) => setTimeout(resolve, 0));

      const element = div.querySelector("#certificate");
      element.style.width = `${a4WidthPx}px`;
      element.style.height = `${a4HeightPx}px`;

      // Ensure images are loaded
      const images = element.querySelectorAll("img");
      const loadPromises = Array.from(images).map(
        (img) =>
          new Promise((resolve, reject) => {
            if (img.complete) resolve();
            else {
              img.onload = resolve;
              img.onerror = () =>
                reject(new Error(`Failed to load image: ${img.src}`));
            }
          })
      );
      await Promise.all(loadPromises);

      // Capture the element with html2canvas, adjusting for zoom
      const canvas = await html2canvas(element, {
        scale: 2 * scaleFactor, // Adjust scale to counteract zoom and ensure high quality
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        width: a4WidthPx,
        height: a4HeightPx,
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.95);
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
        compress: true,
      });

      // A4 dimensions in mm
      const pdfWidth = 297;
      const pdfHeight = 210;

      // Add image to PDF, ensuring it fills the A4 page
      pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);

      const pdfBlob = pdf.output("blob");
      const formData = new FormData();
      formData.append(
        "file",
        pdfBlob,
        `certificate_${Date.now()}_${index}.pdf`
      );

      const response = await axios.post(
        `${uri}/fileservice/api/files/upload`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (!response.data?.id) {
        throw new Error("Failed to upload PDF");
      }

      return response.data.id;
    } catch (error) {
      console.error("Error generating or uploading PDF:", error);
      throw error;
    } finally {
      document.body.removeChild(div);
    }
  };

  const handleSaveCsv = async () => {
    if (!csvFile) {
      showErrorToast("Please upload a CSV file");
      return;
    }
    if (!bulkCertificateType) {
      showErrorToast("Please select a certificate type");
      return;
    }
    if (!csvData.length) {
      showErrorToast("CSV file is empty");
      return;
    }

    try {
      setIsBulkUploadLoading(true);

      const certificateType = bulkCertificateType.toLowerCase();

      const requiredFields = {
        internship: [
          "recipientName",
          "courseType",
          "startDate",
          "endDate",
          "duration",
          "issueDate",
        ],
        appreciation: ["recipientName", "department", "issueDate"],
        achievement: ["recipientName", "department", "issueDate"],
        hackathon_winner: ["recipientName", "hackathonName", "issueDate"],
        hackathon_participation: [
          "recipientName",
          "hackathonName",
          "issueDate",
        ],
        best_team: ["recipientName", "teamName", "issueDate"],
        course_completion: [
          "recipientName",
          "courseName",
          "issueDate",
          "startDate",
          "endDate",
        ],
        training_completion: [
          "recipientName",
          "courseName",
          "issueDate",
          "startDate",
          "endDate",
        ],
        most_valuable_person: ["recipientName", "issueDate"],
        leaders_choice: ["recipientName", "issueDate"],
        great_work: ["recipientName", "issueDate"],
        star_of_the_month: ["recipientName", "issueDate"],
        star_of_the_quarter: ["recipientName", "issueDate"],
        star_performer: ["recipientName", "issueDate"],
      };

      const normalizeKey = (key) =>
        key
          .trim()
          .replace(/\s(.)/g, (match, group1) => group1.toUpperCase())
          .replace(/\s/g, "")
          .replace(/^\w/, (c) => c.toLowerCase());

      // Filter out empty rows
      const cleanedCsvData = csvData
        .map((row) => {
          const cleanedRow = {};
          Object.keys(row).forEach((key) => {
            cleanedRow[normalizeKey(key)] = row[key]?.trim?.() || "";
          });
          return cleanedRow;
        })
        .filter((row) => {
          // Check if the row has any non-empty values
          return Object.values(row).some(
            (value) => value && value.trim() !== ""
          );
        });

      if (!cleanedCsvData.length) {
        showErrorToast("No valid data found in the CSV file");
        return;
      }

      const missingFields = [];
      cleanedCsvData.forEach((row, index) => {
        const required = requiredFields[certificateType] || [];
        required.forEach((field) => {
          if (!row[field] || row[field].trim() === "") {
            missingFields.push(`Row ${index + 1}: Missing or empty ${field}`);
          }
        });
      });

      if (missingFields.length > 0) {
        showErrorToast(`Invalid CSV data:\n${missingFields.join("\n")}`);
        return;
      }

      const payload = await Promise.all(
        cleanedCsvData.map(async (row, index) => {
          const certificatePdfId = await generateCertificatePDF(
            row,
            certificateType,
            index
          );

          const baseDto = {
            certificateType: bulkCertificateType.toUpperCase(),
            certificateName:
              row.certificateName ||
              `${bulkCertificateType
                .replace(/_/g, " ")
                .toUpperCase()} Certificate`,
            companyName: row.companyName || "Elbert Technology",
            email: row.email || "",
            mobileNumber: row.mobileNumber || "",
            certificatePdf: certificatePdfId,
          };

          if (certificateType === "internship") {
            Object.assign(baseDto, {
              internName: row.recipientName || "",
              courseType: row.courseType || "",
              startDate: row.startDate || "",
              endDate: row.endDate || "",
              duration: Number(row.duration) || 0,
              issuedDate: row.issueDate || "",
            });
          } else if (
            certificateType === "appreciation" ||
            certificateType === "achievement"
          ) {
            Object.assign(baseDto, {
              internName: row.recipientName || "",
              department: row.department || "",
              issuedDate: row.issueDate || "",
            });
          } else if (
            certificateType === "hackathon_winner" ||
            certificateType === "hackathon_participation"
          ) {
            Object.assign(baseDto, {
              internName: row.recipientName || "",
              hackathonName: row.hackathonName || "",
              issuedDate: row.issueDate || "",
            });
          } else if (certificateType === "best_team") {
            Object.assign(baseDto, {
              internName: row.recipientName || "",
              teamName: row.teamName || "",
              issuedDate: row.issueDate || "",
            });
          } else if (
            certificateType === "course_completion" ||
            certificateType === "training_completion"
          ) {
            Object.assign(baseDto, {
              internName: row.recipientName || "",
              courseName: row.courseName || "",
              issuedDate: row.issueDate || "",
              startDate: row.startDate || "",
              endDate: row.endDate || "",
            });
          } else {
            Object.assign(baseDto, {
              internName: row.recipientName || "",
              issuedDate: row.issueDate || "",
              startDate: row.startDate || "",
              endDate: row.endDate || "",
            });
          }

          return {
            certificateType: bulkCertificateType.toUpperCase(),
            certificateDto: baseDto,
          };
        })
      );

      if (!payload.length) {
        showErrorToast("No valid certificates were prepared.");
        return;
      }

      console.log("Prepared payload:", JSON.stringify(payload, null, 2));

      const apiResponse = await postJsonRaw(api.CREATE_CERTIFICATE, payload);

      if (apiResponse) {
        showSuccessToast("Bulk certificates uploaded successfully");
        toggleModal();
        fetchData(searchQuery, currentPage, selectedCertificateType);
      } else {
        showErrorToast("Failed to upload bulk certificates");
      }
    } catch (error) {
      console.error("Error processing bulk certificates:", error);
      showErrorToast(`Failed to process bulk certificates: ${error.message}`);
    } finally {
      setIsBulkUploadLoading(false);
    }
  };

  const summaryData = [
    {
      iconClass: "fas fa-certificate text-primary",
      label: "Total Certificates",
      value: countsByType.totalCount,
    },
    {
      iconClass: "fas fa-briefcase text-info",
      label: "Internship",
      value: countsByType.INTERNSHIP,
    },
    {
      iconClass: "fas fa-handshake text-success",
      label: "Appreciation",
      value: countsByType.APPRECIATION,
    },
    {
      iconClass: "fas fa-trophy text-warning",
      label: "Achievement",
      value: countsByType.ACHIEVEMENT,
    },
    {
      iconClass: "fas fa-medal text-warning",
      label: "Hackathon Winner",
      value: countsByType.HACKATHON_WINNER,
    },
    {
      iconClass: "fas fa-code text-primary",
      label: "Hackathon Participation",
      value: countsByType.HACKATHON_PARTICIPATION,
    },
    {
      iconClass: "fas fa-star text-warning",
      label: "Most Valuable Person",
      value: countsByType.MOST_VALUABLE_PERSON,
    },
    {
      iconClass: "fas fa-users-cog text-indigo-500",
      label: "Best Team",
      value: countsByType.BEST_TEAM,
    },
    {
      iconClass: "fas fa-user-tie text-info",
      label: "Leader’s Choice",
      value: countsByType.LEADERS_CHOICE,
    },
    {
      iconClass: "fas fa-graduation-cap text-blue-500",
      label: "Course Completion",
      value: countsByType.COURSE_COMPLETION,
    },
    {
      iconClass: "fas fa-chalkboard-teacher text-info ",
      label: "Training Completion",
      value: countsByType.TRAINING_COMPLETION,
    },
    {
      iconClass: "fas fa-thumbs-up text-success",
      label: "Great Work",
      value: countsByType.GREAT_WORK,
    },
    {
      iconClass: "fas fa-star-half-alt text-warning",
      label: "Star of the Month",
      value: countsByType.STAR_OF_THE_MONTH,
    },
    {
      iconClass: "fas fa-certificate text-warning",
      label: "Star of the Quarter",
      value: countsByType.STAR_OF_THE_QUARTER,
    },
    {
      iconClass: "fas fa-award text-warning",
      label: "Star Performer",
      value: countsByType.STAR_PERFORMER,
    },
  ];

  const formatCertificateType = (type) => {
    if (!type) return "";
    return type
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <>
      <div className="page-content">
        <Container fluid style={{ padding: "0px", gap: "10px" }}>
          <PageSubHeader
            heading={"Certificates Summary"}
            routePath={"Home"}
            pageName={"Certificates"}
          />
          <Row className="p-4">
            <SummaryCards data={summaryData} />
            <Row className="align-items-center row-gap-3 justify-content-between">
              <Col md={4} className="d-flex gap-2">
                <InputGroup size="sm" className="elbert-search-group">
                  <Input
                    type="text"
                    placeholder="Search by certificate name or person name"
                    onChange={handleSearch}
                    value={searchQuery}
                    className="elbert-search"
                  />
                  <InputGroupText>
                    <span className="fa fa-search"></span>
                  </InputGroupText>
                </InputGroup>
                <FormGroup>
                  <Label
                    for="certificateTypeSelect"
                    className="visually-hidden"
                  >
                    Certificate Type
                  </Label>
                  <SelectInput
                    type="select"
                    name="certificateType"
                    id="certificateTypeSelect"
                    value={selectedCertificateType}
                    onChange={handleCertificateTypeChange}
                    style={{ width: "150px" }}
                  >
                    {certificateTypes.map((type, index) => (
                      <option key={index} value={type}>
                        {formatCertificateType(type)}
                      </option>
                    ))}
                  </SelectInput>
                </FormGroup>
              </Col>
              <Col xs="auto" className="d-flex gap-2">
                <CustomButton
                  text={"+ Add New"}
                  onClick={() => navigate("/add-new-certificates")}
                />
                <CustomButton text={"+ Add Bulk "} onClick={toggleModal} />
              </Col>
            </Row>

            <Row className="py-3">
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <div className="table-responsive">
                      <Table className="table mb-0">
                        <thead>
                          <tr>
                            <th style={{ width: "12%" }}>
                              Certification Number
                            </th>
                            <th style={{ width: "20%" }}>Person Name</th>
                            <th style={{ width: "18%" }}>Certificate Type</th>
                            <th style={{ width: "18%" }}>Mobile Number</th>
                            <th style={{ width: "20%" }}>Email</th>
                            <th style={{ width: "10%" }}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {totalCertificates?.certificates?.map(
                            (cert, index) => (
                              <tr key={index}>
                                <td style={{ width: "12%" }}>
                                  {cert.certificateNumber}
                                </td>
                                <td style={{ width: "20%" }}>
                                  {cert.internName || cert.emp_name}
                                </td>
                                <td style={{ width: "18%" }}>
                                  {formatCertificateType(cert.certificateType)}
                                </td>
                                <td style={{ width: "18%" }}>
                                  {cert.mobileNumber}
                                </td>
                                <td style={{ width: "20%" }}>{cert.email}</td>
                                <td
                                  style={{ width: "10%" }}
                                  className="text-center"
                                >
                                  <div className="d-flex gap-3 align-items-center">
                                    <i
                                      onClick={() => handleView(cert.id)}
                                      className="fa-solid fa-eye action-icon"
                                      title="View"
                                    ></i>
                                    <i
                                      onClick={() => handleEdit(cert.id)}
                                      className="fa-regular fa-pen-to-square action-icon"
                                      title="Edit"
                                    ></i>
                                    <i
                                      onClick={() =>
                                        handleDownload(
                                          cert.certificatePdf,
                                          cert.certificateNumber
                                        )
                                      }
                                      className="fa-solid fa-download action-icon"
                                      title="Download"
                                    ></i>
                                  </div>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </Table>
                    </div>
                    {totalCertificates.error && (
                      <p className="text-danger text-center m-3">
                        {totalCertificates.error}
                      </p>
                    )}
                    {!apiStatus.loading &&
                      !totalCertificates.certificates.length &&
                      !totalCertificates.error && (
                        <p className="text-center m-3">No certificates found</p>
                      )}
                    {apiStatus.loading && (
                      <p className="text-center m-3">Loading...</p>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Row>

          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </Container>

        <Modal isOpen={isModalOpen} toggle={toggleModal} centered>
          <ModalHeader toggle={toggleModal}>
            Upload Bulk Certificates
          </ModalHeader>
          <ModalBody>
            {isBulkUploadLoading ? (
              <div className="text-center">
                <Spinner color="primary" />
                <p className="mt-2">Processing bulk upload, please wait...</p>
              </div>
            ) : (
              <>
                <FormGroup>
                  <Label for="bulkCertificateType">
                    Select Certificate Type{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <SelectInput
                    type="select"
                    name="bulkCertificateType"
                    id="bulkCertificateType"
                    value={bulkCertificateType}
                    onChange={handleBulkCertificateTypeChange}
                    className="form-select"
                    disabled={isBulkUploadLoading}
                  >
                    <option value="">-- Select --</option>
                    <option value="internship">Internship</option>
                    <option value="appreciation">Appreciation</option>
                    <option value="achievement">Achievement</option>
                    <option value="hackathon_winner">Hackathon Winner</option>
                    <option value="hackathon_participation">
                      Hackathon Participation
                    </option>
                    <option value="most_valuable_person">
                      Most Valuable Person (MVP)
                    </option>
                    <option value="best_team">Best Team</option>
                    <option value="leaders_choice">Leader’s Choice</option>
                    <option value="great_work">Great Work</option>
                    <option value="star_of_the_month">Star of the Month</option>
                    <option value="star_of_the_quarter">
                      Star of the Quarter
                    </option>
                    <option value="star_performer">Star Performer</option>
                    <option value="course_completion">Course Completion</option>
                    <option value="training_completion">
                      Training Completion
                    </option>
                  </SelectInput>
                </FormGroup>
                <div className="mb-3 d-flex align-items-center gap-2">
                  <Button
                    color="primary"
                    outline
                    className="waves-effect waves-light"
                    onClick={triggerFileInput}
                    disabled={isBulkUploadLoading}
                  >
                    Upload CSV
                  </Button>
                  <input
                    type="file"
                    accept=".csv"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleCsvUpload}
                    disabled={isBulkUploadLoading}
                  />
                  {bulkCertificateType && (
                    <Button
                      color="primary"
                      outline
                      className="waves-effect waves-light"
                      onClick={handleDownloadExampleExcel}
                      disabled={isBulkUploadLoading}
                    >
                      Download Example Excel
                    </Button>
                  )}
                </div>

                {csvData.length > 0 && (
                  <div className="table-responsive">
                    <h6>CSV Preview</h6>
                    <Table className="table table-bordered table-sm">
                      <thead>
                        <tr>
                          {Object.keys(csvData[0]).map((key, index) => (
                            <th key={index}>{key}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {csvData.map((row, rowIndex) => (
                          <tr key={rowIndex}>
                            {Object.values(row).map((value, colIndex) => (
                              <td key={colIndex}>{value}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              outline
              className="waves-effect waves-light"
              onClick={toggleModal}
              disabled={isBulkUploadLoading}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              className="waves-effect waves-light"
              onClick={handleSaveCsv}
              disabled={isBulkUploadLoading}
            >
              Generate and Upload
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
}

export default Certificates;
